import React from 'react';
import Select from 'react-select';

function searchControl() {
  const options = [
    { value: 'chocolate', label: <i className="icon-add_to_colour_group" /> },
    { value: 'strawberry', label: <i className="icon-add_to_colour_group" /> },
    { value: 'vanilla', label: <i className="icon-add_to_colour_group" /> },
  ];

  return (
    <div className="common-search-container">
      <Select
        options={options}
        className="common-select"
        menuPosition="Fixed"
        value={{ value: 'chocolate', label: <i className="icon-add_to_colour_group" /> }}
        classNamePrefix="search-select"
      />
      <input type="text" className="form-control" placeholder="Search" />
    </div>
  );
}

export default searchControl;
